import { useEffect, useState } from 'react';
import { axiosInstance } from '../../../shared/api/axiosInstance';
import { apiRequests } from '../../../shared/api/apiRequests';
import { observer } from 'mobx-react-lite';
import { formatImageUrl } from '../../../shared/utils/formatImageUrl';
import { Link } from 'react-router-dom';
import { Delete } from '../../../features/DeleteEntity/index.js';

export const Product = ({ data, deleteHandler }) => {
  const [image, setImage] = useState('');

  const encodeImageUrl = (url) => {
    try {
      const urlParts = url.split(/(\/\/[^\/]+)/);
      if (urlParts.length >= 3) {
        const encodedPath = urlParts[2]
          .split('/')
          .map((segment) =>
            segment.includes('.')
              ? segment
                  .split('.')
                  .map((part) => encodeURIComponent(part))
                  .join('.')
              : encodeURIComponent(segment),
          )
          .join('/');
        return urlParts[0] + urlParts[1] + encodedPath;
      }
      return encodeURI(url);
    } catch (error) {
      console.error('Error encoding URL:', error);
      return url;
    }
  };

  useEffect(() => {
    if (data.mainImage && data.mainImage.imgPath) {
      console.log('Image path found:', data.mainImage.imgPath);
      try {
        let imageUrl = data.mainImage.imgPath;

        if (imageUrl.startsWith('/uploads/')) {
          imageUrl = `${import.meta.env.VITE_API_URL}${imageUrl}`;
          console.log('Converted to absolute URL:', imageUrl);
        }

        const encodedUrl = encodeImageUrl(imageUrl);
        console.log('Encoded image URL:', encodedUrl);

        setImage(encodedUrl);

        const img = new Image();
        img.onload = () => {
          console.log('Image loaded successfully');
        };
        img.onerror = () => {
          console.log('Error loading image, using fallback');
          setImage('/placeholder.png');
        };
        img.src = encodedUrl;
      } catch (error) {
        console.error('Error setting image URL:', error);
        setImage('/placeholder.png');
      }
    } else {
      console.log('No image path found in data:', data);
      setImage('/placeholder.png');
    }
  }, [data]);

  const handleDelete = async () => {
    await apiRequests.products.delete(data.id).then(() => deleteHandler(data.id));
  };

  return (
    <div className="col-md-3 mb-3">
      <div className="goods-item">
        <div className="goods-image" style={{ backgroundImage: `url(${formatImageUrl(image)})` }}>
          <div className="remote">
            <div className="actions">
              <a href={`/shop/products/${data.id}/modifiers`}>
                <i className="bi bi-collection"></i>
              </a>
              <Link to={`${window.location.pathname}/${data.id}/localization`} className={'action'}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 12V7.6C3 7.03995 3 6.75992 3.10899 6.54601C3.20487 6.35785 3.35785 6.20487 3.54601 6.10899C3.75992 6 4.03995 6 4.6 6H6"
                    stroke="#33363F"
                    strokeWidth="2"
                  />
                  <path
                    d="M21 12V7.6C21 7.03995 21 6.75992 20.891 6.54601C20.7951 6.35785 20.6422 6.20487 20.454 6.10899C20.2401 6 19.9601 6 19.4 6H18"
                    stroke="#33363F"
                    strokeWidth="2"
                  />
                  <path d="M5 4L8 6L5 8V4Z" fill="#33363F" />
                  <path d="M19 4L16 6L19 8V4Z" fill="#33363F" />
                  <path
                    d="M15 15.6C15 15.0399 15 14.7599 15.109 14.546C15.2049 14.3578 15.3578 14.2049 15.546 14.109C15.7599 14 16.0399 14 16.6 14H17L18 15H19.4C19.9601 15 20.2401 15 20.454 15.109C20.6422 15.2049 20.7951 15.3578 20.891 15.546C21 15.7599 21 16.0399 21 16.6V18.4C21 18.9601 21 19.2401 20.891 19.454C20.7951 19.6422 20.6422 19.7951 20.454 19.891C20.2401 20 19.9601 20 19.4 20H16.6C16.0399 20 15.7599 20 15.546 19.891C15.3578 19.7951 15.2049 19.6422 15.109 19.454C15 19.2401 15 18.9601 15 18.4V15.6Z"
                    stroke="#33363F"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3 15.6C3 15.0399 3 14.7599 3.10899 14.546C3.20487 14.3578 3.35785 14.2049 3.54601 14.109C3.75992 14 4.03995 14 4.6 14H5L6 15H7.4C7.96005 15 8.24008 15 8.45399 15.109C8.64215 15.2049 8.79513 15.3578 8.89101 15.546C9 15.7599 9 16.0399 9 16.6V18.4C9 18.9601 9 19.2401 8.89101 19.454C8.79513 19.6422 8.64215 19.7951 8.45399 19.891C8.24008 20 7.96005 20 7.4 20H4.6C4.03995 20 3.75992 20 3.54601 19.891C3.35785 19.7951 3.20487 19.6422 3.10899 19.454C3 19.2401 3 18.9601 3 18.4V15.6Z"
                    stroke="#33363F"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 4.6C9 4.03995 9 3.75992 9.10899 3.54601C9.20487 3.35785 9.35785 3.20487 9.54601 3.10899C9.75992 3 10.0399 3 10.6 3H11L12 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.4C15 7.96005 15 8.24008 14.891 8.45399C14.7951 8.64215 14.6422 8.79513 14.454 8.89101C14.2401 9 13.9601 9 13.4 9H10.6C10.0399 9 9.75992 9 9.54601 8.89101C9.35785 8.79513 9.20487 8.64215 9.10899 8.45399C9 8.24008 9 7.96005 9 7.4V4.6Z"
                    stroke="#33363F"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
              <Link to={`${window.location.pathname}/${data.id}`} className={'action edit'}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.204 10.796L19 9C19.5453 8.45475 19.8179 8.18213 19.9636 7.88803C20.2409 7.32848 20.2409 6.67152 19.9636 6.11197C19.8179 5.81788 19.5453 5.54525 19 5C18.4548 4.45475 18.1821 4.18213 17.888 4.03639C17.3285 3.75911 16.6715 3.75911 16.112 4.03639C15.8179 4.18213 15.5453 4.45475 15 5L13.1814 6.81866C14.1452 8.46926 15.5314 9.84482 17.204 10.796ZM11.7269 8.27311L4.8564 15.1436C4.43134 15.5687 4.21881 15.7812 4.07907 16.0423C3.93934 16.3034 3.88039 16.5981 3.7625 17.1876L3.1471 20.2646C3.08058 20.5972 3.04732 20.7635 3.14193 20.8581C3.23654 20.9527 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0607 7.95771 19.9209C8.21881 19.7812 8.43134 19.5687 8.8564 19.1436L15.7458 12.2542C14.1241 11.2386 12.7524 9.87627 11.7269 8.27311Z"
                    fill="#198754"
                  />
                </svg>
              </Link>
              <button className="action remove">
                <Delete onConfirm={() => handleDelete()} />
              </button>
            </div>
          </div>
        </div>
        <div className="goods-content">
          <div className="name">{data.title}</div>
          <div className="goods-desc">
            <div className="categories">{data.category.title}</div>
            <div className="cost">
              {data.basePrice?.currency.title} {data.basePrice?.currency.symbol}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
